import api from './index'
import type { V1ApiResponse } from '@/types'

export const APP_CONFIG_TYPE = 'APP_CONF'
export const APP_PC_HOME_CONF_CODE = 'APP_PC_HOME_CONF'
export const APP_PC_BASIC_CONF_CODE = 'APP_PC_BASIC_CONF'

export interface AppPcBasicSideBarMenuItem {
  id: string
  icon?: string
  iconImage?: string
  label: string
  action: string
  danger?: boolean
}

export interface AppPcBasicConfig {
  userGuideUrl?: string
  sideBarMoreMenu?: AppPcBasicSideBarMenuItem[]
  /** 账号注销冷静期文案，如「15天」 */
  account_cancel_label?: string
  /** 账号注销冷静期倒计时（秒） */
  account_cancel_countdown?: number
}

export interface AppConfigData<T = unknown> {
  configType: string
  typeCode: string
  typeName?: string | null
  config: T
}

export const appConfigApi = {
  query: <T = unknown>(params: {
    type_code: string
    config_type: string
  }): Promise<V1ApiResponse<AppConfigData<T>>> =>
    api.get('/v1/app-configs', {
      params,
      noAuthRedirect: true,
    } as any),
}

export default appConfigApi
